import { t } from '../locale';

export default {
  methods: {
    t(...args) {
      return t.apply(this, args);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/QnUpload-1.0.0/mixins/locale.js